import { RowCrudStatus } from "../../common/types";
import {
  PublisherRepresentative,
  PublisherRepresentative_CreateInput,
  PublisherRepresentative_UpdateInput,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { blankToNull } from "../../../common/blankToNull";

export type PublisherRepresentativeValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name: string;
  role: string;
  email: string;
  phone: string;
  isSigner: boolean;
};

export type PublisherRepresentativeErrorsType = {
  name?: { message: string; fieldLabel: string };
  role?: { message: string; fieldLabel: string };
  email?: { message: string; fieldLabel: string };
  phone?: { message: string; fieldLabel: string };
  isSigner?: { message: string; fieldLabel: string };
};

export function PublisherRepresentativeValuesInit(): PublisherRepresentativeValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name: "",
    role: "",
    email: "",
    phone: "",
    isSigner: false,
  };
}

export type PublisherRepresentativeType =
  | PublisherRepresentative
  | PublisherRepresentativeValuesType;

export function publisherRepresentativeDisplayId(
  source: Partial<PublisherRepresentative>,
  _langStore: LangStore
) {
  return source.name ?? _langStore.emptyStringSymbol;
}

export function getPublisherRepresentativeValues(
  source: PublisherRepresentativeType,
  _langStore: LangStore,
  _duplicated: boolean = false
): PublisherRepresentativeValuesType {
  const entityValues = PublisherRepresentativeValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : publisherRepresentativeDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name = source.name;
  entityValues.role = source.role || "";
  entityValues.email = source.email;
  entityValues.phone = source.phone || "";
  entityValues.isSigner = source.isSigner || false;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getPublisherRepresentativeUpdateInput(
  values: PublisherRepresentativeValuesType
): PublisherRepresentative_UpdateInput {
  return {
    id: values.id,
    version_: values.version_,
    name: values.name,
    role: blankToNull(values.role),
    email: values.email,
    phone: blankToNull(values.phone),
    isSigner: values.isSigner === undefined ? null : values.isSigner,
  };
}

export function getPublisherRepresentativeCreateInput(
  values: PublisherRepresentativeValuesType
): PublisherRepresentative_CreateInput {
  return {
    name: values.name,
    role: blankToNull(values.role),
    email: values.email,
    phone: blankToNull(values.phone),
    isSigner: values.isSigner === undefined ? null : values.isSigner,
  };
}
